import { render, staticRenderFns } from "./ResultsSlide.vue?vue&type=template&id=575efd44"
import script from "./ResultsSlide.vue?vue&type=script&lang=js"
export * from "./ResultsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('575efd44')) {
      api.createRecord('575efd44', component.options)
    } else {
      api.reload('575efd44', component.options)
    }
    module.hot.accept("./ResultsSlide.vue?vue&type=template&id=575efd44", function () {
      api.rerender('575efd44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/ResultsSlide.vue"
export default component.exports